// Default "Failed" toast text for each login step, used when the server gives
// no reason of its own.
export const LOGIN_ERROR_MESSAGES = {
  accountLookup: "Unable to verify your details right now. Please try again.",
  login: "Unable to log in right now. Please try again.",
  googleLogin: "Google sign-in failed. Please try again.",
  loadContacts: "Unable to load your contact details. Please try again.",
  sendOtp: "Unable to send the verification code. Please try again.",
  verifyOtp: "Unable to verify the code right now. Please try again.",
  resendOtp: "Unable to resend the code. Please try again.",
};

// The message to show when a server call fails. `error` is either what a
// rejected thunk hands back (the server's error body, see authSlice's
// rejectWithServerError), a `success: false` reply, or a plain error from a
// network failure.
//
// The server's own reason wins when it has one meant for the customer:
//   body.data.msg / body.data.message / body.data as a string, or the top-level
//   `message` of a 4xx reply ("Too many attempts. Please try again later.").
// A 5xx reply's top-level `message` is the raw exception text from the server
// ("Cannot read properties of undefined…"), and a network error's message is
// axios text ("Network Error"), so those fall back to the screen's default.
// So does the top-level `message` of a 200 reply, which is the success text.
export const getApiErrorMessage = (error: any, fallback: string): string => {
  const data = error?.body?.data;
  const candidates = [data?.msg, data?.message, data];

  const status = Number(error?.status);
  if (status >= 400 && status < 500) {
    candidates.push(error?.message);
  }

  const message = candidates.find(
    (candidate) => typeof candidate === "string" && candidate.trim() !== ""
  );
  return message ? message.trim() : fallback;
};
